var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconButton, makeStyles } from "@material-ui/core";
const sizeToPx = {
    small: 24,
    medium: 36,
    large: 40,
};
export default React.forwardRef((_a, ref) => {
    var { size, children, className = "", disableBackground, color = "secondary" } = _a, otherProps = __rest(_a, ["size", "children", "className", "disableBackground", "color"]);
    const classes = useStyles({ size, disableBackground, color });
    return (React.createElement(IconButton, Object.assign({ ref: ref }, otherProps, { className: classes.root + " " + className }), children));
});
const useStyles = makeStyles((theme) => ({
    root: ({ size = "medium", disableBackground, color = "inherit", }) => ({
        width: sizeToPx[size],
        height: sizeToPx[size],
        backgroundColor: disableBackground ? "transparent !important" : "initial",
        color: color !== "inherit" ? theme.palette.icon[color] : "inherit",
        borderRadius: "50%",
        "& svg": {
            color: "inherit",
        },
    }),
}));
//# sourceMappingURL=FTLIconButton.js.map